export default {
  props: {
    data: {
      type: [Array, Boolean, Date, Number, Object, String],
      required: false
    },
    default: {
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mappings: {
      type: Array,
      required: false
    },
    property: {
      required: true
    },
    propertyName: {
      required: true
    },
    required: {
      type: Boolean,
      required: false
    },
  },
  data: () => ({
    localData: null
  }),
  created() {
    this.localData = this.data || this.default
    this.$emit('update:data', this.localData, this.isValidInput())
  },
  methods: {
    isValidDate(d) {
      return d instanceof Date && !Number.isNaN(parseFloat(d))
    },
    isValidInput() {
      return !(this.required && !this.localData && !this.disabled)
    },
    toSentence(str) {
      const strippedString = str.trim()
      const formattedString = strippedString.replace(/^[a-z]|[^\s][A-Z]/g, (string, offset) => {
        if (offset === 0) {
          return string.toUpperCase()
        }
        return `${string.substr(0, 1)} ${string.substr(1).toUpperCase()}`
      })
      return formattedString
    }
  },
  computed: {
    requiredLabel() {
      return `${this.toSentence(this.propertyName)} is required`
    },
    label() {
      return `${(this.property.description || this.property.title || this.toSentence(this.propertyName))} ${this.required ? '*' : ''}`
    },
    booleanLabel() {
      return this.property.description || this.property.title || this.toSentence(this.propertyName)
    }
  },
  accepts() {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/components/metadataeditor/template/base.js